import { render, staticRenderFns } from "./InviteList.vue?vue&type=template&id=3cb1fdd2&"
import script from "./InviteList.vue?vue&type=script&lang=js&"
export * from "./InviteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports